//viniith code

import React, { useState, useEffect } from "react";
import {
  getAuth,
  verifyPasswordResetCode,
  confirmPasswordReset,
  sendPasswordResetEmail,
} from "firebase/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ref, update, get } from "firebase/database"; // Import update and get methods
import { db } from "../../firebase-config";
const ForgotPassword = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [mode, setMode] = useState(null);
  const [oobCode, setOobCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isResetting, setIsResetting] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const actionMode = queryParams.get("mode");
    const code = queryParams.get("oobCode");

    if (actionMode === "resetPassword" && code) {
      setMode(actionMode);
      setOobCode(code);

      // Verify the reset code and get the associated email
      const auth = getAuth();
      verifyPasswordResetCode(auth, code)
        .then((email) => setEmail(email))
        .catch(() => toast.error("Invalid or expired reset code."));
    }
  }, [location.search]);

  const handleForgotPassword = async () => {
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      toast.success("Password reset email sent successfully!", {
        position: "top-center",
      });
    } catch (error) {
      console.error("Error sending password reset email", error.message);
      toast.error("Failed to send password reset email", {
        position: "top-center",
      });
    }
  };

  const handleResetPassword = async () => {
    if (newPassword.length < 6) {
      toast.error("Password should be 6 or more characters long", {
        position: "top-center",
      });
      return;
    }
    setIsResetting(true);
    try {
      const auth = getAuth();
      // Verify code and get associated email
      const userEmail = await verifyPasswordResetCode(auth, oobCode);
      await confirmPasswordReset(auth, oobCode, newPassword);
      toast.success("Password has been reset successfully!", {
        position: "top-center",
      });

      // Update password in Firebase Realtime Database
      const dbRef = ref(db, `superadmin`);
      const snapshot = await get(dbRef);
      const data = snapshot.val();

      if (data.Email === userEmail) {
        // Update password for superadmin
        await update(ref(db, `superadmin`), { Password: newPassword });
      } else if (data.admins) {
        // Iterate through admins
        Object.entries(data.admins).forEach(async ([key, adminData]) => {
          if (adminData.Email === userEmail) {
            // Update password for admin
            await update(ref(db, `superadmin/admins/${key}`), {
              Password: newPassword,
            });
          } else if (adminData.technicians) {
            // Iterate through technicians within admin
            Object.entries(adminData.technicians).forEach(
              async ([techKey, techData]) => {
                if (techData.Email === userEmail) {
                  // Update password for technician
                  await update(
                    ref(db, `superadmin/admins/${key}/technicians/${techKey}`),
                    { Password: newPassword }
                  );
                }
              }
            );
          } else if (adminData.doctors) {
            // Iterate through doctors within admin
            Object.entries(adminData.doctors).forEach(
              async ([docKey, docData]) => {
                if (docData.Email === userEmail) {
                  // Update password for doctor
                  await update(
                    ref(db, `superadmin/admins/${key}/doctors/${docKey}`),
                    { Password: newPassword }
                  );
                }
              }
            );
          }
        });
      }

      // Clear the password input and navigate to login
      setNewPassword("");
      navigate("/"); // Redirect to the login page after success
    } catch (error) {
      console.error("Error resetting password", error.message);
      toast.error("Failed to reset password", {
        position: "top-center",
      });
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          width: "100%",
          backgroundColor: "white",
          padding: "2rem",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "8px",
        }}
      >
        {mode === "resetPassword" ? (
          <>
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: "600",
                marginBottom: "1.5rem",
              }}
            >
              Reset Password
            </h2>
            <p>Email: {email}</p> {/* Display email */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  color: "#4a4a4a",
                }}
              >
                New Password:
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{
                    marginTop: "0.25rem",
                    padding: "0.5rem",
                    width: "100%",
                    border: "1px solid #d1d5db",
                    borderRadius: "4px",
                    paddingRight: "2rem", // Adjust padding for icon
                  }}
                />
                <span
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  style={{
                    position: "absolute",
                    right: "0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#4a4a4a",
                  }}
                >
                  {isPasswordVisible ? (
                    <i className="fas fa-eye-slash"></i>
                  ) : (
                    <i className="fas fa-eye"></i>
                  )}
                </span>
              </div>
            </div>
            <button
              onClick={handleResetPassword}
              style={{
                width: "100%",
                backgroundColor: "#3b82f6",
                color: "white",
                padding: "0.5rem",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#2563eb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#3b82f6")
              }
              disabled={isResetting}
            >
              {isResetting ? "Resetting..." : "Reset Password"}
            </button>
          </>
        ) : (
          <>
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: "600",
                marginBottom: "1.5rem",
              }}
            >
              Forgot Password
            </h2>
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  color: "#4a4a4a",
                }}
              >
                Email:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  marginTop: "0.25rem",
                  padding: "0.5rem",
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                }}
              />
            </div>
            <button
              onClick={handleForgotPassword}
              style={{
                width: "100%",
                backgroundColor: "#3b82f6",
                color: "white",
                padding: "0.5rem",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#2563eb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#3b82f6")
              }
            >
              Send Reset Link
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

//minal code sucess///

// import React, { useState } from "react";
// import { getAuth, sendPasswordResetEmail } from "firebase/auth";
// import { getDatabase, ref, update, get, child } from "firebase/database";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");
//   const [newPassword, setNewPassword] = useState(""); // To capture new password
//   const [message, setMessage] = useState(""); // State to hold the message
//   const navigate = useNavigate(); // Initialize the useNavigate hook

//   const handleForgotPassword = async () => {
//     try {
//       const auth = getAuth();
//       const db = getDatabase();

//       // Find email in Realtime Database
//       const snapshot = await get(child(ref(db), "superadmin/admins"));

//       // Check if email exists in your database
//       if (snapshot.exists()) {
//         const admins = snapshot.val();
//         const adminKey = Object.keys(admins).find(
//           (key) => admins[key].Email === email
//         );

//         if (adminKey) {
//           // Send password reset email via Firebase Authentication
//           await sendPasswordResetEmail(auth, email);
//           toast.success("Password reset email sent successfully!");

//           setMessage("A link to reset your password has been sent to your email. Please use the new password you have entered to reset your password via the link provided. Check your inbox and follow the instructions to complete the reset.");

//           navigate('/'); // Redirect to home page on success// Prompt user to input a new password (after resetting via email)
//           // Store the new password as plain text
//           await update(ref(db, `/superadmin/admins/${adminKey}`), {
//             Password: newPassword, // Store plain text password
//             lastPasswordUpdate: new Date().toISOString(), // Optional: to track when the password was updated
//           });

//         } else {
//           toast.error("Email not found in Realtime Database.");
//         }
//       } else {
//         toast.error("No admins found in the database.");
//       }
//     } catch (error) {
//       console.error("Error resetting password:", error.message);
//       toast.error("Failed to reset or update password.");
//     }
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "400px",
//           width: "100%",
//           backgroundColor: "white",
//           padding: "2rem",
//           boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//           borderRadius: "8px",
//         }}
//       >
//         <h2
//           style={{
//             fontSize: "1.5rem",
//             fontWeight: "600",
//             marginBottom: "1.5rem",
//           }}
//         >
//           Forgot Password
//         </h2>
//         <div style={{ marginBottom: "1rem" }}>
//           <label
//             style={{
//               display: "block",
//               fontSize: "0.875rem",
//               fontWeight: "500",
//               color: "#4a4a4a",
//             }}
//           >
//             Email:
//           </label>
//           <input
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             style={{
//               marginTop: "0.25rem",
//               padding: "0.5rem",
//               width: "100%",
//               border: "1px solid #d1d5db",
//               borderRadius: "4px",
//             }}
//           />
//         </div>

//         <div style={{ marginBottom: "1rem" }}>
//           <label
//             style={{
//               display: "block",
//               fontSize: "0.875rem",
//               fontWeight: "500",
//               color: "#4a4a4a",
//             }}
//           >
//             New Password:
//           </label>
//           <input
//             type="password"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             style={{
//               marginTop: "0.25rem",
//               padding: "0.5rem",
//               width: "100%",
//               border: "1px solid #d1d5db",
//               borderRadius: "4px",
//             }}
//           />
//         </div>

//         <button
//           onClick={handleForgotPassword}
//           style={{
//             width: "100%",
//             backgroundColor: "#3b82f6",
//             color: "white",
//             padding: "0.5rem",
//             borderRadius: "4px",
//             border: "none",
//             cursor: "pointer",
//             transition: "background-color 0.3s ease",
//           }}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.backgroundColor = "#2563eb")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.backgroundColor = "#3b82f6")
//           }
//         >
//           Reset Password
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
